var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File Size Exceeded Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 44",
    cx: 37,
    cy: 37,
    r: 37,
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.1429 48.1667V54M47.1429 42.3333H47.1621M39.4286 19V27.5556C39.4286 28.6445 39.4286 29.189 39.6388 29.605C39.8237 29.9708 40.1186 30.2683 40.4816 30.4547C40.8941 30.6667 41.4341 30.6667 42.5143 30.6667H51M39.4286 19H30.1714C28.0112 19 26.9311 19 26.106 19.4239C25.3803 19.7967 24.7902 20.3916 24.4204 21.1234C24 21.9552 24 23.0442 24 25.2222V47.7778C24 49.9557 24 51.0448 24.4204 51.8767C24.7902 52.6084 25.3803 53.2034 26.106 53.5761C26.9311 54 28.0112 54 30.1714 54H39.4286M39.4286 19L51 30.6667M51 30.6667V35.5278",
    stroke: "white",
    strokeWidth: 3.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSize);
export default __webpack_public_path__ + "static/media/fileSize.f53da48258fce621bc4c5bbff4a900f5.svg";
export { ForwardRef as ReactComponent };